import HundredBricksAPIError from '../../../HundredBricksAPIError';
class PropertyDeveloperError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('PropertyDeveloperError', ...args);
    }
}
export default PropertyDeveloperError;
